'use strict';

export default {
  loginPage: {
    username: 'Username',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    stayconnected: 'Remember Me',
    wrongCombination: 'Your email/password combination is incorrect',
    or: 'Or',
    emailError: 'Email is a required field',
    passwordError: 'Password is a required field',
    confirmPassword: 'Confirm Password',
    confirmPasswordError: 'Password confirmation is a required field',
    firstName: 'First Name',
    lastName: 'Last Name',
    firstNameError: 'First name is a required field',
    lastNameError: 'Last name is a required field',
    firstNameLengthError: 'First name must be between 2 and 50 characters',
    lastNameLengthError: 'Last name must be between 2 and 50 characters',
    emailValidError: 'Email must be valid',
    passwordMustMatchError: 'Passwords must match',
    confirmPasswordRequiredError: 'Confirm Password is a required field',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    logIn: 'Log in',
    signUp: 'Sign up',
    awaitingActivation: 'Awaiting account activation. Please check your email.',
    emailExistsError: 'An account with this email already exists.',
    fromRegistrationToCelebration: 'From Registration to Celebration!',
    welcomeBack: 'Welcome back! Please login to your account.',
  },
  activateAccountPage: {
    activatingAccount: 'Activating account...',
    activationSuccess: 'Your account has been successfully activated. You can now log in.',
    activationFailure: 'Failed to activate account. Please check your activation link or contact support.',
    backToLogin: 'Back to login',
    login: 'Log in',
  },
  accountCreatedPage: {
    accountCreatedSuccess:
      'Congratulations! Your Kreezee account has been successfully created. An email has been sent to you to activate your account.',
    backToLogin: 'Back to login',
  },
};
